import { requestApi } from '../util/network'
// 跑腿类目列表
export const getErrandClassList =
    () =>
      requestApi(
        '/o2o_errand_class/get_list',
        'POST',
        {
        }
      )
// 跑腿类目
export const getErrandClassInfo =
    (id) =>
      requestApi(
        '/o2o_errand_class/get_info',
        'POST',
        {
          id: id
        }
      )
// 新增跑腿订单
export const addErrandOrder =
    (orderInfo) =>
      requestApi(
        '/member_o2o_errand_order/add',
        'POST',
        {
          o2o_errand_order_type: orderInfo.o2o_errand_order_type,
          o2o_errand_order_appointment_time: orderInfo.o2o_errand_order_appointment_time,
          o2o_errand_order_pickup_region_id: orderInfo.o2o_errand_order_pickup_region_id,
          o2o_errand_order_pickup_lng: orderInfo.o2o_errand_order_pickup_lng,
          o2o_errand_order_pickup_lat: orderInfo.o2o_errand_order_pickup_lat,
          o2o_errand_order_deliver_region_id: orderInfo.o2o_errand_order_deliver_region_id,
          o2o_errand_order_deliver_lng: orderInfo.o2o_errand_order_deliver_lng,
          o2o_errand_order_deliver_lat: orderInfo.o2o_errand_order_deliver_lat,
          o2o_errand_order_weight: orderInfo.o2o_errand_order_weight,
          o2o_errand_order_pickup_name: orderInfo.o2o_errand_order_pickup_name,
          o2o_errand_order_pickup_address: orderInfo.o2o_errand_order_pickup_address,
          o2o_errand_order_pickup_address_floor: orderInfo.o2o_errand_order_pickup_address_floor,
          o2o_errand_order_pickup_note: orderInfo.o2o_errand_order_pickup_note,
          o2o_errand_order_pickup_phone: orderInfo.o2o_errand_order_pickup_phone,
          o2o_errand_order_deliver_name: orderInfo.o2o_errand_order_deliver_name,
          o2o_errand_order_deliver_address: orderInfo.o2o_errand_order_deliver_address,
          o2o_errand_order_deliver_address_floor: orderInfo.o2o_errand_order_deliver_address_floor,
          o2o_errand_order_deliver_note: orderInfo.o2o_errand_order_deliver_note,
          o2o_errand_order_deliver_phone: orderInfo.o2o_errand_order_deliver_phone,
          o2o_errand_order_detail: orderInfo.o2o_errand_order_detail,
          o2o_errand_order_goods_price: orderInfo.o2o_errand_order_goods_price,
          o2o_errand_order_remark: orderInfo.o2o_errand_order_remark,
          o2o_errand_order_gratuity: orderInfo.o2o_errand_order_gratuity,
          o2o_errand_order_check_receive: orderInfo.o2o_errand_order_check_receive,
          o2o_errand_order_if_pay_on_behalf: orderInfo.o2o_errand_order_if_pay_on_behalf,
          o2o_errand_order_pay_on_behalf_amount: orderInfo.o2o_errand_order_pay_on_behalf_amount,
          o2o_errand_order_invoice_id: orderInfo.invoiceId,
        },
        'member'
      )
// 获取支付订单
export const getErrandOrderPay =
    (paySn) =>
      requestApi(
        '/member_o2o_errand_order/pay',
        'POST',
        {
          pay_sn: paySn
        },
        'member'
      )
// 获取用户订单列表
export const getErrandOrderList =
    (parmas, state) =>
      requestApi(
        '/member_o2o_errand_order/get_list',
        'POST',
        {
          'page': parmas.page,
          'per_page': parmas.per_page,
          'o2o_errand_order_state': state
        },
        'member'
      )
// 获取订单信息
export const getErrandOrderInfo =
    (orderId) =>
      requestApi(
        '/member_o2o_errand_order/get_info',
        'POST',
        {
          'o2o_errand_order_id': orderId
        },
        'member'
      )
// 取消订单
export const cancelErrandOrder =
    (orderId) =>
      requestApi(
        '/member_o2o_errand_order/cancel',
        'POST',
        {
          'o2o_errand_order_id': orderId
        },
        'member'
      )
export const receiveErrandOrder =
    (orderId) =>
      requestApi(
        '/member_o2o_errand_order/receive',
        'POST',
        {
          'o2o_errand_order_id': orderId
        },
        'member'
      )
export const sendErrandOrderReceiveCode =
    (orderId) =>
      requestApi(
        '/member_o2o_errand_order/send_receive_code',
        'POST',
        {
          'o2o_errand_order_id': orderId
        },
        'member'
      )
export const evaluateErrandOrder =
    (orderId, score, comment) =>
      requestApi(
        '/member_o2o_errand_order/evaluate',
        'POST',
        {
          'o2o_errand_order_id': orderId,
          'score': score,
          'comment': comment
        },
        'member'
      )

/**
 * 取得跑腿費用明細
 *
 * @param {Object} payload
 * @returns Promise
 */
export const getErrandOrderDetailForFeePayment =
    (payload) =>
      requestApi(
        '/MemberO2oErrandOrder/detailForFeePayment',
        'POST',
        {
          'o2o_errand_order_appointment_time': payload.o2o_errand_order_appointment_time,
          'o2o_errand_order_pickup_lat': payload.o2o_errand_order_pickup_lat,
          'o2o_errand_order_pickup_lng': payload.o2o_errand_order_pickup_lng,
          'o2o_errand_order_deliver_lat': payload.o2o_errand_order_deliver_lat,
          'o2o_errand_order_deliver_lng': payload.o2o_errand_order_deliver_lng,
          'o2o_errand_order_weight': payload.o2o_errand_order_weight,
          'o2o_errand_order_gratuity': payload.o2o_errand_order_gratuity
        },
        'member'
      )
